import { render, staticRenderFns } from "./SingleSelect.vue?vue&type=template&id=65b81eb7&scoped=true&"
import script from "./SingleSelect.vue?vue&type=script&lang=js&"
export * from "./SingleSelect.vue?vue&type=script&lang=js&"
import style0 from "./SingleSelect.vue?vue&type=style&index=0&id=65b81eb7&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "65b81eb7",
  null
  
)

export default component.exports